import React, { useState } from 'react';

import CustomSelect from '../common/CustomSelect';
import { formatLocationName } from '../../helpers/providers';
import { useGetLocationsQuery } from '../../redux/services/locationApi';

const SelectLocationInput = props => {
  // const [search, setSearch] = useState('');
  const searchQuery = useGetLocationsQuery({category: 'team'});
  return (
    <CustomSelect
      label={props?.label || 'Select Location'}
      disabled={props?.disabled || searchQuery.isLoading}
      options={(searchQuery?.data?.data || []).map(loc => ({
        label: loc.name, 
        value: loc.id,
      }))}
      {...props}
      onChange={e => {
        // setSearch(e.target.value);
        props.onChange(e, e.target.value);
      }}
    />
  );
};

export default SelectLocationInput;